module.exports = __webpack_public_path__ + "static/projekty_pl-81ad75cfb9092150ecf7346ce88ce6a0.png";